import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.5.8_next@15.5.7_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.95.1__react@19.2.1_typescript@5.9.3/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.5.8_next@15.5.7_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.95.1__react@19.2.1_typescript@5.9.3/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/react-loading-skeleton@3.5.0_react@19.2.1/node_modules/react-loading-skeleton/dist/index.js");
;
import(/* webpackMode: "eager" */ "/app/src/ui/List/List.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/ui/layout/ListView/ListView.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/ui/InfoBar/InfoBar.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/ui/MaskIcon/MaskIcon.module.scss");
